var _excluded = ["className", "thickness", "isIndented", "isOffset", "isInverse", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import StyledDivider from './divider.styles';
import { StyledCacheWrapper } from '../../styles';
import InverseContext from '../../utilities/inverse-context';
var dividerProps = {
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** Specifies the thickness of divider. For thicker than default, choose between thick, thicker, thickest. */
  thickness: PropTypes.oneOf(['default', 'thick', 'thicker', 'thickest']),
  /** Specifies if the divider is indented to it's left and right an equal amount. */
  isIndented: PropTypes.bool,
  /** Specifies if the divider is offset from the left of it's container. */
  isOffset: PropTypes.bool,
  /** Add utility objects for styling */
  utils: PropTypes.object,
  /** Set to true if divider is on a dark background. */
  isInverse: PropTypes.oneOf(['auto', true, false])
};
var dividerPropsDefault = {
  className: '',
  thickness: 'default',
  isIndented: false,
  isOffset: false,
  utils: {},
  isInverse: 'auto'
};

/**
 * @ignore @description
 * ## Divider Component
 * The Divider is a component that represents a thematic break between paragraph-level elements much like a horizontal rule element.
 *
 * @ignore @see Mesh: [Divider Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/visual-elements-divider--default)
 *
 * @ignore @example
 * ```jsx
 * import { Box, Divider } from 'mesh-component-library';
 *
 * <Box>
 *  <Divider {...props}/>
 * </Box>
 * ```
 */

var Divider = function Divider(props) {
  var className = props.className,
    thickness = props.thickness,
    isIndented = props.isIndented,
    isOffset = props.isOffset,
    isInverse = props.isInverse,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  var useIsInverse = useContext(InverseContext);
  if (isInverse !== 'auto') useIsInverse = isInverse;
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledDivider, _extends({
    className: className,
    thickness: thickness,
    isIndented: isIndented,
    isOffset: isOffset,
    utils: utils,
    isInverse: useIsInverse
  }, other)));
};
Divider.propTypes = dividerProps;
Divider.defaultProps = dividerPropsDefault;
export default Divider;